



























































import Moment from "moment";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Table } from "element-ui";
import InfiniteLoading from "vue-infinite-loading";
import { NameSpecifiedEntity } from "../../../../base/domain/entity";
import { IEditableFormatOperation, TargetKinds, OperationKinds } from "../../../domain/editableFormat";
import { ForceUseInfiniteWrapperForInfiniteLoadingMixin } from "../../../../base/components/system/mixins";

type TargetKindsKey = keyof typeof TargetKinds;
const TargetKindDictionary: {[key in TargetKindsKey]: string } = {
  Directory: "フォルダ",
  Format: "フォーマット",
};

type OperationKindsKey = keyof typeof OperationKinds;
const OperationKindDictionary: {[key in OperationKindsKey]: string } = {
  Add: "追加",
  Move: "移動",
  Delete: "削除",
  Rename: "名称変更",
  Revert: "版数変更",
  Update: "改版",
  Revive: "削除取消",
  Redisplay: "再表示",
};

@Component({
  components: {
    InfiniteLoading
  },
})
export default class EditHistoryTableViewer extends Mixins(ForceUseInfiniteWrapperForInfiniteLoadingMixin) {
  @Prop()
  operations: IEditableFormatOperation[];

  get loadChunkSize(): number {
    // TODO: コンフィグ追加する
    // const settingCount = this.$configuration.behavior.document.list.infiniteLoader.rowCount;
    // return settingCount ? settingCount : 30; // 設定がなかった時のためにデフォルト値
    return 30;
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  private replaceWording(text: string): string {
    return text.replace(/フォーマット/g, this.formatNameWording);
  }

  @Watch("operations")
  onOperationsUpdated(newValue: IEditableFormatOperation[], oldValue: IEditableFormatOperation[]): void {
    this.$logger.debug("onOperationsUpdated..");

    this.loadedOperations = [];
    this.chunkedCount = 0;

    if (this.$refs.infiniteLoading) {
      this.$logger.debug("call reset.");
      this.$refs.infiniteLoading.stateChanger.reset();
    }
  }

  chunkedCount: number = 0;
  loadedOperations: IEditableFormatOperation[] = [];

  $refs!: {
    table: Table,
    infiniteLoading: InfiniteLoading
  };

  mounted(): void {
    this.updateForceUseInfiniteWrapper(this.$refs.table.$el as HTMLElement, this.$refs.infiniteLoading);
  }

  toDateString(source: Date): string {
    return Moment(source).format("YY/MM/DD");
  }

  toTimeString(source: Date): string {
    return Moment(source).format("HH:mm");
  }

  toEntityLabel<T>(source: NameSpecifiedEntity<T>): string {
    return source
      ? source.toString()
      : "";
  }

  toEntityId<T>(source: NameSpecifiedEntity<T>): string {
    return source
      ? " (" + source.id.toString() + ")"
      : "";
  }

  toTargetKindString(source: TargetKinds): string {
    return this.replaceWording(TargetKindDictionary[TargetKinds[source] as TargetKindsKey]);
  }

  toOperationKindString(source: OperationKinds): string {
    return OperationKindDictionary[OperationKinds[source] as OperationKindsKey];
  }

  onInfinite(): void {
    this.$logger.debug("onInfinite");
    this.chunkList();
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  private chunkList(): void {
    this.$logger.debug("chunkList");
    for (let i = this.chunkedCount; i < (this.chunkedCount + this.loadChunkSize); i++) {
      if (i >= this.operations.length) {
        this.$logger.debug("call complete. i is " + i);
        this.$refs.infiniteLoading.stateChanger.complete();
        return;
      }

      this.loadedOperations.push(this.operations[i]);
    }
    this.chunkedCount += this.loadChunkSize;

    this.$logger.debug("call loaded. chunkedCount is " + this.chunkedCount);
    this.$refs.infiniteLoading.stateChanger.loaded();
  }
}
